import { ReactNode } from 'react';

const PwdFalseArgs = (): ReactNode => <>pwd: Too many arguments</>;

const PwdCorrectArg = ({ currentPath }: { currentPath: string }): ReactNode => <>{currentPath}</>;

export { PwdFalseArgs, PwdCorrectArg };
